module.exports = __webpack_public_path__ + "img/shapes.75324f7e.svg";